import React, { useState, Fragment, useEffect } from "react";
import "./css/style.css";
import PersonalInformation from "./PersonalInformation";
import BankInformation from "./BankInformation";
import MedicalRegistration from "./MedicalRegistration";
import connectLogo from "./images/connect-logo.png";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import sessionExpiredError from "../Errors/sessionExpiredError";
import swal from "sweetalert";

const DoctorOnboarding = (props) => {
  const [state, setState] = useState({
    dsmOnboarding: false,
    personalInformation: {
      submitPersonalInformation: false,
    },
    bankInformation: {
      submitBankInformation: false,
    },
    medicalRegistrationNDocuments: {
      submitMedicalRegistration: false,
    },
    selectedScreen: "Personal Information",
  });
  const [refetchapi, setrefetchapi] = useState(0);
  const [referral, setReferral] = useState("");

  useEffect(() => {
    localStorage.removeItem("doctor_application_id");
    if (props.match?.params?.slug) {
      setState({ ...state, loading: true });
      afterLoginApiAxios({
        method: "post",
        url: "public/get-doctor-details-by-unique-link",
        data: {
          onboard_application_url: props.match.params.slug,
        },
      })
        .then((response) => {
          setState({ ...state, loading: false });
          if (response.status === 200) {
            if (response.data.statusCode === 200) {
              localStorage.setItem(
                "doctor_application_id",
                response.data.data.id
              );
              if (response.data.data.doctor_details.referral_code) {
                setReferral(response.data.data.doctor_details.referral_code);
              }

              if (response.data?.data?.step == 1) {
                let personalInformation = {
                  ...state.personalInformation,
                  ...response.data?.data?.personal_information,
                  submitPersonalInformation: true,
                };
                setState({
                  ...state,
                  dsmOnboarding: response.data?.data?.doctor_details,
                  personalInformation,
                  selectedScreen: "Bank Information",
                });
              } else if (response.data?.data?.step == 2) {
                let personalInformation = {
                  ...state.personalInformation,
                  ...response.data?.data?.personal_information,
                  submitPersonalInformation: true,
                };
                let bankInformation = {
                  ...state.bankInformation,
                  ...response.data?.data?.bank_details,
                  submitBankInformation: true,
                };
                setState({
                  ...state,
                  dsmOnboarding: response.data?.data?.doctor_details,
                  personalInformation,
                  bankInformation,
                  selectedScreen:
                    "Medical Registration Number & Document Upload",
                });
              } else {
                setState({
                  ...state,
                  dsmOnboarding: response.data?.data?.doctor_details,
                });
              }
            } else if (response.data.statusCode === 504) {
              const Msg = swal({
                title: "All details are already filled!",
                text:
                  "Customer Happiness Team will review the application. You will be soon notified once your application is processed.",
                icon: "warning",
                button: "OK",
              })
              .then(() => {
                localStorage.removeItem("doctor_application_id");
                props.history.push("/");
              });
              return Msg;
            } else if (response.data.statusCode === 503) {
              const Msg = swal({
                title: "Onboard application URL does not exist",
                icon: "warning",
                button: "OK",
              }).then(() => {
                localStorage.removeItem("doctor_application_id");
                props.history.push("/");
              });
              return Msg;
            } else if (response.data.statusCode === 502) {
              const Msg = swal({
                title: "Onboard application URL is mandatory",

                icon: "warning",
                button: "OK",
              }).then(() => {
                localStorage.removeItem("doctor_application_id");
                props.history.push("/");
              });
              return Msg;
            }
          }
        })
        .catch((error) => {
          if (error?.response?.status === 403) {
            sessionExpiredError(() => {
              localStorage.clear();
              props.history.push("/admin/auth/login");
            });
          }
        });
    }
  }, [refetchapi]);

  const setPersonalData = (personalData) => {
    const personalInformation = personalData;
    setState({
      ...state,
      personalInformation,
      selectedScreen: "Bank Information",
    });
  };

  const setBankData = (bankData) => {
    const bankInformation = bankData;
    setState({
      ...state,
      bankInformation,
      selectedScreen: "Medical Registration Number & Document Upload",
    });
  };

  const setMedicalRegistrationData = (MedicalData) => {
    const medicalRegistrationNDocuments = MedicalData;
    setState({
      ...state,
      medicalRegistrationNDocuments,
      // selectedScreen: "Medical Registration Number & Document Upload",
    });
  };

  const setPrevious = (previousTab) => {
    setState({ ...state, selectedScreen: previousTab });
  };

  const handleTab = (e) => {
    setState({ ...state, selectedScreen: e.target.name });
  };

  return (
    <div className="connect2">
      <div className="top-header">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="logo-main">
                <img src={connectLogo} />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="top-right-content">
                <p>
                  This form needs to fill up by the practicing health care
                  professionals to onboard on Connect2Clinic platform
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="noe-consult">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="anywhere">
                <h1>
                  Now consult
                  <span>Anywhere. Anytime.</span>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="onboarding-form">
        <div className="container">
          <article className="tabbed-content  tabs-side article-tab-side">
            <div className="tab-select-sec">
              <h3>Doctor Onboarding Form</h3>
              <nav className="tabs article-tab">
                <ul id="tabs" className="nav nav-tabs">
                  <li>
                    <a
                      href="#side_tab1"
                      name="Personal Information"
                      className={
                        state.selectedScreen == "Personal Information"
                          ? "active"
                          : ""
                      }
                      // onClick={handleTab}
                    >
                      Personal Informations
                    </a>
                  </li>
                  <li>
                    <a
                      href="#side_tab2"
                      name="Bank Information"
                      className={
                        state.selectedScreen == "Bank Information"
                          ? "active"
                          : ""
                      }
                      // onClick={handleTab}
                    >
                      Bank Information
                    </a>
                  </li>
                  <li>
                    <a
                      href="#side_tab3"
                      name="Medical Registration Number & Document Upload"
                      className={
                        state.selectedScreen ==
                        "Medical Registration Number & Document Upload"
                          ? "active"
                          : ""
                      }
                      // onClick={handleTab}
                    >
                      Medical Registration Number & Document Upload
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="tab-form-sec">
              <div className="article-tab-content">
                {state.selectedScreen === "Personal Information" ? (
                  <PersonalInformation
                    submitData={setPersonalData}
                    isFilled={state.personalInformation}
                    dsmOnboarding={state.dsmOnboarding}
                    refetchapi={() => setrefetchapi(refetchapi + 1)}
                  />
                ) : state.selectedScreen == "Bank Information" ? (
                  <BankInformation
                    submitData={setBankData}
                    previousTab={setPrevious}
                    isFilled={state.bankInformation}
                  />
                ) : (
                  <MedicalRegistration
                    submitData={setMedicalRegistrationData}
                    previousTab={setPrevious}
                    isFilled={state.medicalRegistrationNDocuments}
                    referral_code={referral}
                  />
                )}
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  );
};

export default DoctorOnboarding;
